import React, { useState, useEffect, useCallback } from 'react';
import { Wifi } from 'lucide-react';

const FAMOUS_SPIES = [
  { name: 'James Bond', code: '007', org: 'MI6', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Hubert Bonisseur de La Bath', code: 'OSS 117', org: 'SDECE', flag: '\u{1F1EB}\u{1F1F7}' },
  { name: 'Ethan Hunt', code: '', org: 'IMF', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Jim Phelps', code: '', org: 'IMF Force', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Jason Bourne', code: '', org: 'CIA / Treadstone', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'George Smiley', code: '', org: 'Le Cirque (MI6)', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Jack Ryan', code: '', org: 'CIA', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Austin Powers', code: '', org: 'MI6', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Napoleon Solo', code: '', org: 'U.N.C.L.E.', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Illya Kuryakin', code: '', org: 'U.N.C.L.E.', flag: '\u{1F1F7}\u{1F1FA}' },
  { name: 'Harry Palmer', code: '', org: 'MI5', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Felix Leiter', code: '', org: 'CIA', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'M', code: '', org: 'MI6 Director', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Q', code: '', org: 'MI6 Tech Division', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Miss Moneypenny', code: '', org: 'MI6', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Maxwell Smart', code: 'Agent 86', org: 'CONTROL', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Nikita', code: '', org: 'La Division', flag: '\u{1F1EB}\u{1F1F7}' },
  { name: 'Evelyn Salt', code: '', org: 'CIA / SVR', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Mata Hari', code: 'Agent H-21', org: 'Freelance', flag: '\u{1F1F3}\u{1F1F1}' },
  { name: 'Malotru', code: '', org: 'DGSE', flag: '\u{1F1EB}\u{1F1F7}' },
  { name: 'Benji Dunn', code: '', org: 'IMF Tech', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Luther Stickell', code: '', org: 'IMF', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Alec Trevelyan', code: '006', org: 'MI6 (ex)', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Ernst Stavro Blofeld', code: 'N\u00B01', org: 'SPECTRE', flag: '\u{1F3F4}\u200D\u2620\uFE0F' },
  { name: 'Derek Flint', code: '', org: 'Z.O.W.I.E.', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Natalya Simonova', code: '', org: 'GRU Crypto', flag: '\u{1F1F7}\u{1F1FA}' },
  { name: 'Xenia Onatopp', code: '', org: 'Janus Syndicate', flag: '\u{1F1F7}\u{1F1FA}' },
  { name: 'Vesper Lynd', code: '', org: 'HM Treasury / Double', flag: '\u{1F1EC}\u{1F1E7}' },
  { name: 'Larmina El Akmar Betouche', code: '', org: 'SDECE Stagiaire', flag: '\u{1F1EB}\u{1F1F7}' },
  { name: 'Fran\u00E7ois Merlin', code: '', org: 'DGSE / BdL', flag: '\u{1F1EB}\u{1F1F7}' },
  { name: 'Le Chiffre', code: '', org: 'SMERSH', flag: '\u{1F3F4}\u200D\u2620\uFE0F' },
  { name: 'Rosa Klebb', code: '', org: 'SMERSH / Col. 3', flag: '\u{1F1F7}\u{1F1FA}' },
  { name: 'Oddjob', code: '', org: 'Goldfinger Inc.', flag: '\u{1F1F0}\u{1F1F7}' },
  { name: 'Jaws', code: '', org: 'Freelance', flag: '\u{1F3F4}\u200D\u2620\uFE0F' },
  { name: 'Dominique Pinon', code: 'OSS 1500', org: 'DGSE Retraite', flag: '\u{1F1EB}\u{1F1F7}' },
  { name: 'Sydney Bristow', code: 'Freelancer', org: 'SD-6 / CIA', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Chuck Bartowski', code: 'The Intersect', org: 'NSA / CIA', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Sterling Archer', code: '', org: 'ISIS', flag: '\u{1F1FA}\u{1F1F8}' },
  { name: 'Natasha Romanoff', code: 'Black Widow', org: 'KGB / S.H.I.E.L.D.', flag: '\u{1F1F7}\u{1F1FA}' },
  { name: 'Lorraine Broughton', code: '', org: 'MI6 / Atomic Blonde', flag: '\u{1F1EC}\u{1F1E7}' },
];

const ACTIONS = [
  'online',
  'surveille ce site',
  'a rejoint le r\u00E9seau',
  'connect\u00E9(e)',
  'en mission',
  'infiltr\u00E9(e)',
  'observe depuis un parking',
  'v\u00E9rifie vos cookies',
  'a enregistr\u00E9 votre IP',
  'est en planque en bas de chez vous',
  'lit vos emails',
  'photographie votre \u00E9cran',
];

const AgentNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [onlineCount, setOnlineCount] = useState(47);

  const addNotification = useCallback(() => {
    const spy = FAMOUS_SPIES[Math.floor(Math.random() * FAMOUS_SPIES.length)];
    const action = ACTIONS[Math.floor(Math.random() * ACTIONS.length)];
    const id = Date.now() + Math.random();

    const label = spy.code
      ? `${spy.name} (${spy.code} \u2014 ${spy.org})`
      : `${spy.name} (${spy.org})`;

    setNotifications(prev => [...prev.slice(-2), { id, label, flag: spy.flag, action }]);
    setOnlineCount(c => c + Math.floor(Math.random() * 3) + 1);

    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 4500);
  }, []);

  useEffect(() => {
    const first = setTimeout(addNotification, 3000);
    const interval = setInterval(addNotification, 5000 + Math.random() * 4000);
    return () => { clearTimeout(first); clearInterval(interval); };
  }, [addNotification]);

  return (
    <>
      {/* Online counter badge - fixed bottom left */}
      <div className="fixed bottom-4 left-4 z-50 flex items-center gap-2 bg-black/80 backdrop-blur-md border border-green-500/30 rounded-full px-4 py-2 shadow-lg" data-testid="agents-online-badge">
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
        </span>
        <span className="text-green-400 text-xs font-mono">{onlineCount} agents online</span>
        <Wifi className="w-3 h-3 text-green-500" />
      </div>

      {/* Notification toasts - fixed bottom right */}
      <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none max-w-sm" data-testid="agent-notifications">
        {notifications.map(n => (
          <div
            key={n.id}
            className="animate-slide-in-right bg-black/90 backdrop-blur-md border border-[#d4c5a9]/30 rounded-lg px-4 py-3 shadow-2xl pointer-events-auto"
            data-testid="agent-notification-toast"
          >
            <div className="flex items-center gap-3">
              <span className="text-xl">{n.flag}</span>
              <div className="min-w-0">
                <p className="text-[#d4c5a9] text-sm font-medium truncate">{n.label}</p>
                <p className="text-green-400 text-xs font-mono">{n.action}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default AgentNotifications;
